import type { RepairReviewResponse } from "@stryker/core/api/jobs";
import type { Dispatch, SetStateAction } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { ImportantNote } from "@/components/ui/importantNote";
import { Typography } from "@/components/ui/typography";

type RepairReviewProps = {
  showRepairModal: boolean;
  setShowRepairModal: Dispatch<SetStateAction<boolean>>;
  dataForSubmit: any;
  selectedRepairSystemName?: string;
  repairReviewData?: RepairReviewResponse | null;
  setShowConfirmModal: Dispatch<SetStateAction<boolean>>;
  setRepairReviewData: Dispatch<SetStateAction<RepairReviewResponse | null>>;
};
export default function RepairReviewModal({
  showRepairModal,
  setShowRepairModal,
  selectedRepairSystemName,
  dataForSubmit,
  repairReviewData,
  setShowConfirmModal,
  setRepairReviewData,
}: RepairReviewProps) {
  return (
    <Dialog open={showRepairModal} onOpenChange={() => setShowRepairModal(false)}>
      <DialogContent>
        <DialogTitle className="sr-only">Repair review details</DialogTitle>
        <div className="md md:max-h-auto flex max-h-[380px] flex-col overflow-auto">
          <DialogDescription asChild>
            <ImportantNote>
              Repair review. Ensure repair system is suitable for the service, layer count, and wall loss
            </ImportantNote>
          </DialogDescription>
          <div className="my-8 flex flex-col gap-2">
            <RepairReviewItem value={dataForSubmit.service_name} label="Service:" />
            <RepairReviewItem value={selectedRepairSystemName} label="Repair System:" />
            <RepairReviewItem value={repairReviewData?.layer_count} label="Layer Count:" />
            <RepairReviewItem value={`${repairReviewData?.wall_lose?.toFixed(2)}%`} label="Wall Loss:" />
            {repairReviewData?.error && <RepairReviewItem value={repairReviewData.error} label="Error:" />}
          </div>
          <div className="flex items-center gap-2">
            <Button
              variant="outline"
              className="flex-1"
              onClick={() => {
                setShowRepairModal(false);
                setShowConfirmModal(false);
                setRepairReviewData(null);
              }}
            >
              Cancel
            </Button>
            <Button
              className="flex-1"
              onClick={() => {
                setShowRepairModal(false);
                setTimeout(() => {
                  setShowConfirmModal(true);
                }, 100);
              }}
            >
              Continue
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

function RepairReviewItem({ label, value }: { label: string; value?: string | number | null }) {
  return (
    <div className="flex gap-2 ">
      <Typography className="flex-1" weight="bold">
        {label}
      </Typography>
      <Typography className="flex-1">{value ?? "N/A"}</Typography>
    </div>
  );
}
